export const translations = {
  en: {
    // Main title
    title: 'PlatePeek',
    
    // Mode selection
    chooseModeTitle: 'Choose Game Mode',
    guessCountryFromPlate: 'Guess Country from Plate',
    guessCountryDescription: 'See a license plate\nIdentify the country',
    guessCodeFromCountry: 'Guess Code from Country',
    guessCodeDescription: 'See a country name\nType the plate code',
    
    // Difficulty selection
    chooseDifficultyTitle: 'Choose Your Difficulty',
    chooseDifficultyTitleCode: 'Choose Code Game Difficulty',
    easyMode: 'Easy Mode',
    hardMode: 'Hard Mode',
    easyDescriptionPlate: 'Clear license plates\nPerfect for learning',
    hardDescriptionPlate: 'Blurred license plates\nTest your knowledge',
    easyDescriptionCode: 'Country name shown\nEnter the license plate code',
    hardDescriptionCode: 'Flag image shown\nEnter the license plate code',
    back: '← Back',
    
    // Game UI
    score: 'Score',
    time: 'Time',
    countries: 'Countries',
    plateMode: 'PLATE',
    codeMode: 'CODE',
    easy: 'EASY',
    hard: 'HARD',
    
    // Input placeholders
    enterCountryName: 'Enter country name (e.g., France)',
    enterCountryOrCode: 'Enter country name or code (e.g., France or F)',
    enterCode: 'Enter code (e.g., RKS)',
    
    // Buttons
    submitGuess: 'Submit Guess',
    submitCode: 'Submit Code',
    nextCountry: 'Next Country →',
    viewResults: 'View Results →',
    
    // Feedback
    correct: '✓ Correct! Well done!',
    incorrect: '✗ Incorrect! Try to remember this one.',
    incorrectCode: '✗ Incorrect! Try to remember this code.',
    correctAnswer: 'Correct answer',
    
    // Questions and hints
    whatIsCode: "What's the license plate code?",
    whatIsCountryCode: "What's this country's license plate code?",
    
    // Game over
    gameComplete: '🎉 Game Complete!',
    timeLabel: 'Time',
    modeLabel: 'Mode',
    playAgain: 'Play Again',
    mainMenu: 'Main Menu',
    viewLeaderboard: 'View Leaderboard',
    
    // Leaderboard
    leaderboard: 'Leaderboard',
    leaderboards: 'Leaderboards',
    yourScore: 'Your Score',
    enterUsername: 'Enter your username to save your score:',
    usernamePlaceholder: 'Your username',
    usernameRules: 'Letters, numbers, hyphens, and underscores only (2-20 characters)',
    submitScore: 'Submit Score',
    skipSubmission: 'Skip',
    submitting: 'Submitting...',
    scoreSubmitted: 'Score submitted successfully!',
    yourPosition: 'Your position',
    topPlayers: 'Top Players',
    loading: 'Loading...',
    retry: 'Retry',
    noScoresYet: 'No scores yet. Be the first!',
    rank: 'Rank',
    player: 'Player',
    close: 'Close',
    seeMore: 'See More',
    seeLess: 'See Less',
    usernameAlreadyTaken: 'This username is already taken with a better or equal score',
    submissionError: 'Failed to submit score. Please try again.',
    
    // Score messages
    scoreMessages: {
      code: {
        excellent: '🏆 Outstanding! You know all the country codes!',
        veryGood: '🌟 Excellent! You really know your codes!',
        good: '👏 Good job! Keep practicing those codes!',
        average: '💪 Not bad! Country codes are tricky!',
        poor: '📚 Keep learning! Practice makes perfect!'
      },
      plate: {
        easy: {
          excellent: '🏆 Perfect! You know every European country!',
          veryGood: '🌟 Excellent! Almost perfect on easy mode!',
          good: '👏 Good job! Consider trying hard mode next!',
          average: '💪 Not bad! Keep practicing to improve!',
          poor: '📚 Keep learning! Practice makes perfect!'
        },
        hard: {
          excellent: "🏆 Outstanding! You're a true European license plate expert!",
          veryGood: '🌟 Excellent work on hard mode! Very impressive!',
          good: '👏 Great job tackling hard mode!',
          average: '💪 Good effort on hard mode! It\'s challenging!',
          poor: '📚 Hard mode is tough! Try easy mode to learn!'
        }
      }
    },
    
    // Errors
    imageNotFound: 'Image not found',
    flagNotFound: 'Flag not found'
  },
  
  fr: {
    // Main title
    title: 'PlatePeek',
    
    // Mode selection
    chooseModeTitle: 'Choisis le Mode de Jeu',
    guessCountryFromPlate: 'Devine le Pays depuis la Plaque',
    guessCountryDescription: 'Regarde une plaque d\'immatriculation\nIdentifie le pays',
    guessCodeFromCountry: 'Devine le Code depuis le Pays',
    guessCodeDescription: 'Regarde le nom d\'un pays\nTape le code de la plaque',
    
    // Difficulty selection
    chooseDifficultyTitle: 'Choisis ta Difficulté',
    chooseDifficultyTitleCode: 'Choisis la Difficulté du Jeu des Codes',
    easyMode: 'Mode Facile',
    hardMode: 'Mode Difficile',
    easyDescriptionPlate: 'Plaques d\'immatriculation claires\nParfait pour apprendre',
    hardDescriptionPlate: 'Plaques d\'immatriculation floues\nTeste tes connaissances',
    easyDescriptionCode: 'Nom du pays affiché\nTape le code de la plaque',
    hardDescriptionCode: 'Image du drapeau affichée\nTape le code de la plaque',
    back: '← Retour',
    
    // Game UI
    score: 'Score',
    time: 'Temps',
    countries: 'Pays',
    plateMode: 'PLAQUE',
    codeMode: 'CODE',
    easy: 'FACILE',
    hard: 'DIFFICILE',
    
    // Input placeholders
    enterCountryName: 'Tape le nom du pays (ex: France)',
    enterCountryOrCode: 'Tape le nom du pays ou le code (ex: France ou F)',
    enterCode: 'Tape le code (ex: RKS)',
    
    // Buttons
    submitGuess: 'Valider',
    submitCode: 'Valider le Code',
    nextCountry: 'Pays Suivant →',
    viewResults: 'Voir les Résultats →',
    
    // Feedback
    correct: '✓ Correct ! Bien joué !',
    incorrect: '✗ Incorrect ! Essaie de t\'en souvenir.',
    incorrectCode: '✗ Incorrect ! Essaie de te souvenir de ce code.',
    correctAnswer: 'Bonne réponse',
    
    // Questions and hints
    whatIsCode: "Quel est le code de la plaque d'immatriculation ?",
    whatIsCountryCode: "Quel est le code de plaque de ce pays ?",
    
    // Game over
    gameComplete: '🎉 Jeu Terminé !',
    timeLabel: 'Temps',
    modeLabel: 'Mode',
    playAgain: 'Rejouer',
    mainMenu: 'Menu Principal',
    viewLeaderboard: 'Voir le Classement',
    
    // Leaderboard
    leaderboard: 'Classement',
    leaderboards: 'Classements',
    yourScore: 'Ton Score',
    enterUsername: 'Entre ton nom d\'utilisateur pour sauvegarder ton score :',
    usernamePlaceholder: 'Ton nom d\'utilisateur',
    usernameRules: 'Lettres, chiffres, tirets et underscores uniquement (2-20 caractères)',
    submitScore: 'Enregistrer le Score',
    skipSubmission: 'Ignorer',
    submitting: 'Envoi en cours...',
    scoreSubmitted: 'Score enregistré avec succès !',
    yourPosition: 'Ta position',
    topPlayers: 'Meilleurs Joueurs',
    loading: 'Chargement...',
    retry: 'Réessayer',
    noScoresYet: 'Aucun score pour le moment. Sois le premier !',
    rank: 'Rang',
    player: 'Joueur',
    close: 'Fermer',
    seeMore: 'Voir Plus',
    seeLess: 'Voir Moins',
    usernameAlreadyTaken: 'Ce nom d\'utilisateur est déjà pris avec un score égal ou meilleur',
    submissionError: 'Échec de l\'envoi du score. Réessaie.',
    
    // Score messages
    scoreMessages: {
      code: {
        excellent: '🏆 Extraordinaire ! Tu connais tous les codes de pays !',
        veryGood: '🌟 Excellent ! Tu connais vraiment tes codes !',
        good: '👏 Bon travail ! Continue à t\'entraîner sur ces codes !',
        average: '💪 Pas mal ! Les codes de pays sont difficiles !',
        poor: '📚 Continue d\'apprendre ! C\'est en forgeant qu\'on devient forgeron !'
      },
      plate: {
        easy: {
          excellent: '🏆 Parfait ! Tu connais tous les pays européens !',
          veryGood: '🌟 Excellent ! Presque parfait en mode facile !',
          good: '👏 Bon travail ! Essaie le mode difficile maintenant !',
          average: '💪 Pas mal ! Continue à t\'entraîner pour t\'améliorer !',
          poor: '📚 Continue d\'apprendre ! C\'est en forgeant qu\'on devient forgeron !'
        },
        hard: {
          excellent: '🏆 Extraordinaire ! Tu es un vrai expert des plaques européennes !',
          veryGood: '🌟 Excellent travail en mode difficile ! Très impressionnant !',
          good: '👏 Super travail en mode difficile !',
          average: '💪 Bon effort en mode difficile ! C\'est un défi !',
          poor: '📚 Le mode difficile est dur ! Essaie le mode facile pour apprendre !'
        }
      }
    },
    
    // Errors
    imageNotFound: 'Image non trouvée',
    flagNotFound: 'Drapeau non trouvé'
  }
};